import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { MixpanelService } from '@shared/mixpanel';

@Component({
    selector: 'modal',
    standalone: true,
    imports: [DialogModule, TranslateModule],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
    visible = model.required<boolean>();

    id = input.required<string>();
    title = input<string>('');
    modalType = input<'' | 'modal-success' | 'modal-warning' | 'modal-info'>('');
    modalSize = input<'small' | 'default' | 'medium' | 'large'>('default');
    closable = input<boolean>(true);
    closeInClickOutside = input<boolean>(false);
    focusOnShow = input<boolean>(false);

    modalSizeComputed = computed(() => this.computeModalSize(this.modalSize()));

    constructor(private mixpanel: MixpanelService) {}

    closeModal() {
        this.visible.set(false);
    }

    onDialogShow() {
        const dialog = document.querySelector('.p-dialog');
        const closeButton = dialog?.querySelector('.p-dialog-header-icon') as HTMLElement;

        this.mixpanel.logModalOpen(this.id());

        if (closeButton) {
            closeButton.focus();
        }
    }

    computeModalSize(size: 'small' | 'default' | 'medium' | 'large'): string {
        switch (size) {
            case 'small':
                return '500px';
            case 'default':
                return '600px';
            case 'medium':
                return '750px';
            case 'large':
                return '900px';
            default:
                return '600px';
        }
    }
}
